
import { getFetch, postFetchWithBody, postFetchWithBodyHandler } from "../../utils/fetch";

async function storeFunction(rows) {
  const res = await postFetchWithBodyHandler('/function_registrations', {
    registrations: rows,
  });
  if (res.status === 200 || res.status === 201) {
    return {
      status: "success",
      message: "کارکرد با موفقیت ایجاد شد",
    };
  } else {
    return {
      status: res.status,
      message: res.message,
    };
  }
}
async function downloadAllReport() {
  const data = await getFetch('/ReportWeb/Reports/download-report-function-registration');
  if (data.status !== "error") {
    return {
      status: "success",
      message: data,
    };
  } else {
    return {
      status: data.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}
async function deleteFunction(form) {
  const res = await postFetchWithBody("/function_registrations/delete", form);
  if (res.status !== "error") {
    return {
      status: "success",
      message: res,
    };
  } else {
    return {
      status: res.status,
      message: res.message,
    };
  }
}



export { storeFunction,deleteFunction,downloadAllReport };

